import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const NotifymasterEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		agentcode: yup.string().nullable().label($t('agentcode')),
		other_name: yup.string().nullable().label($t('otherName')),
		complaint_title: yup.string().required().label($t('complaintTitle')),
		complaint_desc: yup.string().nullable().label($t('complaintDesc')),
		complaint_date: yup.string().required().label($t('complaintDate')),
		upload_file_loc: yup.string().nullable().label($t('uploadFileLoc')),
		issue_closed: yup.number().required().label($t('issueClosed'))
	});
	// form default values
	const formDefaultValues = {
		agentcode: '', 
		other_name: '', 
		complaint_title: '', 
		complaint_desc: '', 
		complaint_date: "(getdate())", 
		upload_file_loc: '', 
		issue_closed: "((0))", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/notifymaster`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="NotifymasterEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editNotifymaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('agentcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="agentcode"  onChange={formik.handleChange}  value={formik.values.agentcode}   label={$t('agentcode')} type="text" placeholder={$t('enterAgentcode')}        className={inputClassName(formik?.errors?.agentcode)} />
                                                <ErrorMessage name="agentcode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('otherName')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="other_name"  onChange={formik.handleChange}  value={formik.values.other_name}   label={$t('otherName')} type="text" placeholder={$t('enterOtherName')}        className={inputClassName(formik?.errors?.other_name)} />
                                                <ErrorMessage name="other_name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('complaintTitle')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="complaint_title"  onChange={formik.handleChange}  value={formik.values.complaint_title}   label={$t('complaintTitle')} type="text" placeholder={$t('enterComplaintTitle')}        className={inputClassName(formik?.errors?.complaint_title)} />
                                                <ErrorMessage name="complaint_title" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('complaintDesc')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="complaint_desc"  onChange={formik.handleChange}  value={formik.values.complaint_desc}   label={$t('complaintDesc')} type="text" placeholder={$t('enterComplaintDesc')}        className={inputClassName(formik?.errors?.complaint_desc)} />
                                                <ErrorMessage name="complaint_desc" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('complaintDate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="complaint_date" value={formik.values.complaint_date} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.complaint_date)}        />
                                                <ErrorMessage name="complaint_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('uploadFileLoc')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.upload_file_loc)}>
                                                    <Uploader name="upload_file_loc" showUploadedFiles value={formik.values.upload_file_loc} uploadPath="fileuploader/upload/upload_file_loc" onChange={(paths) => formik.setFieldValue('upload_file_loc', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="upload_file_loc" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('issueClosed')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="issue_closed"  onChange={formik.handleChange}  value={formik.values.issue_closed}   label={$t('issueClosed')} type="number" placeholder={$t('enterIssueClosed')}  min={0}  step="any"    className={inputClassName(formik?.errors?.issue_closed)} />
                                                <ErrorMessage name="issue_closed" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
NotifymasterEditPage.defaultProps = {
	primaryKey: 'notifyid',
	pageName: 'notifymaster',
	apiPath: 'notifymaster/edit',
	routeName: 'notifymasteredit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default NotifymasterEditPage;
